import TinyColor from 'tinycolor2'

export function getClassTextByRGB(rgb) {
    let color = new TinyColor(rgb);

    return 'text-' + (color.getBrightness() > 170 ? 'dark' : 'white')
}
